module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "login-box"
  }, [_c('div', {
    staticClass: "login-logo"
  }, [_c('router-link', {
    attrs: {
      "to": "/home"
    }
  }, [_c('b', {
    staticStyle: {
      "color": "rgb(244, 167, 21)"
    }
  }, [_vm._v("MICRO")]), _vm._v("-FINANCE")])], 1), _vm._v(" "), _c('div', {
    staticClass: "login-box-body"
  }, [_c('p', {
    staticClass: "login-box-msg"
  }, [_vm._v("Sign in to start your session")]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.login($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group has-feedback"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.email),
      expression: "form.email"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "email",
      "type": "email",
      "placeholder": "Email",
      "required": ""
    },
    domProps: {
      "value": (_vm.form.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon glyphicon-envelope form-control-feedback"
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.error.error),
      expression: "error.error"
    }],
    staticClass: "text-danger"
  }, [_vm._v(" => " + _vm._s(_vm.error.error))]), _vm._v(" "), _vm._m(0)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-8"
  }, [_c('div', {
    staticClass: "checkbox icheck"
  }, [_c('label', [_c('div', {
    staticClass: "icheckbox_square-blue",
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "aria-checked": "false",
      "aria-disabled": "false"
    }
  }, [_c('input', {
    staticStyle: {
      "position": "absolute",
      "top": "-20%",
      "left": "-20%",
      "display": "block",
      "width": "140%",
      "height": "140%",
      "margin": "0px",
      "padding": "0px",
      "background": "rgb(255, 255, 255)",
      "border": "0px",
      "opacity": "0"
    },
    attrs: {
      "type": "checkbox"
    }
  }), _c('ins', {
    staticClass: "iCheck-helper",
    staticStyle: {
      "position": "absolute",
      "top": "-20%",
      "left": "-20%",
      "display": "block",
      "width": "140%",
      "height": "140%",
      "margin": "0px",
      "padding": "0px",
      "background": "rgb(255, 255, 255)",
      "border": "0px",
      "opacity": "0"
    }
  })]), _vm._v(" Remember Me\n              ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-block btn-flat",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Submit")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-138e059b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/comman/ForgetPassword.vue
// module id = 765
// module chunks = 0